import { useQuery } from '@tanstack/react-query';
import Button from '../../components/ui/Button';
import { API_BASE_URL } from '../../lib/apiClient';
import { getAuthProviders } from './authApi';

function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
      <path
        fill="#4285F4"
        d="M23.52 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.81Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3.01c-1.07.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.72-4.95H1.27v3.11A12 12 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.28 14.28A7.2 7.2 0 0 1 4.9 12c0-.79.14-1.56.38-2.28V6.61H1.27a12 12 0 0 0 0 10.78l4.01-3.11Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44A11.97 11.97 0 0 0 12 0 12 12 0 0 0 1.27 6.61l4.01 3.11C6.22 6.88 8.87 4.77 12 4.77Z"
      />
    </svg>
  );
}

/**
 * "Continue with Google" — renders nothing unless the backend reports the
 * provider as configured (GET /auth/providers is the single source of truth;
 * no duplicated frontend env flag). A plan chosen before the click (register
 * flow) is forwarded so the backend can seed the pending subscription.
 */
export default function GoogleButton({ planId, billingCycle }) {
  const { data } = useQuery({
    queryKey: ['auth-providers'],
    queryFn: getAuthProviders,
    staleTime: Infinity,
    retry: false,
  });

  if (!data?.google) return null;

  const params = new URLSearchParams();
  if (planId) {
    params.set('plan', planId);
    params.set('cycle', billingCycle === 'annual' ? 'annual' : 'monthly');
  }
  const query = params.size > 0 ? `?${params}` : '';

  return (
    <>
      <div className="my-5 flex items-center gap-3">
        <span className="h-px flex-1 bg-slate-200" />
        <span className="text-xs font-medium uppercase tracking-wide text-slate-400">or</span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>
      <Button
        type="button"
        variant="secondary"
        className="w-full"
        onClick={() => window.location.assign(`${API_BASE_URL}/auth/google${query}`)}
      >
        <GoogleGlyph />
        Continue with Google
      </Button>
    </>
  );
}
